<template>
  <div>
    <slot></slot>
    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>封面圖</th>
        <th>圖片</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in datas.Images" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>
        </td>
        <td >
          <div class="form-check">
            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" :value="item.SystemId" v-model="datas.BannerFileName">
            <label class="form-check-label" for="exampleRadios1">

            </label>
          </div>
        </td>
        <td width="300px">
          <img :src="convertToRealUrl(item.Url)" style="width:300px;height: 200px">
          <FileUploadButtonProductImage :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" :value="item.SystemId" :product-id="productId" ></FileUploadButtonProductImage>
        </td>

      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 無欄位 日期/備註
 <ListEditImage :mode="1"></ListEditImage>

 有欄位 日期/備註
 <ListEditImage :mode="2"></ListEditImage>

 有相簿位置
 <ListEditImage :mode="3"></ListEditImage>

 options
  image-memo="(建議圖片大小:100x100)"
 **/

import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";
import Vue from "vue";
import FileUploadButtonProductImage from "@/views/fireGods/component/FileUploadButtonProductImage.vue";
export default {
  components: {FileUploadButtonProductImage},
  //name: "imageListUpload",
  props: ["datas","productId"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datasDemo: {
        BannerFileName:"",
        Images:[
          {
            SystemId: "",
            OrderKey: "",
            Url: "",
          }
        ]
      }
    };
  },
  methods: {
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas.Images,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas.Images,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={};

      newItem=
          {
            SystemId:"",
            OrderKey:0,
            IsBanner:false,
            Url:"",
          };

      newItem.SystemId =util.uuid() +".png";

      arrayUtil.orderAppendLast(newItem,this.datas.Images,"OrderKey")
    },
    DataItem_Remove(item){// eslint-disable-line
      arrayUtil.removeByPredicate(this.datas.Images,s => s.SystemId===item.SystemId);
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.Url=result.data.FileUrl
      }else{
        alert("檔案上傳失敗")
      }
    },

  },
  mounted() {
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
